import { createDirectStore, } from 'direct-vuex';
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export const Store = (contentMapData: typeof import('./content-map-data.json')) => {
	const {
		store,
	} = createDirectStore({
		state: {
			contentMapData,
		},
	});
	return store;
};
